<template>
  <main class="content">
    <section class="main-section">
      <img
        src="/assets/hero-icons/successful-email-verification.svg"
        alt="successful email verification"
      >
      <div class="successful-text-container">
        <h1 class="successful-title">{{ getTitle }}</h1>
        <a v-if="!isVerified" :href="`${landingURL}`" target="_self">
          <main-button depressed text="nastavi" />
        </a>
        <main-button v-else depressed :text="getButtonText" @click="handleRedirect" />
      </div>
    </section>
  </main>
</template>

<script>
import { CONFIRM_EMAIL, GET_LOGGED_USER } from '../../graphql/user.graphql.js'
import { landingURL } from '@/utils'

const VERIFIED_MESSAGE_RESPONSE = 'User already verified'

export default {
  props: {
    token: {
      type: String,
    },
  },
  data() {
    return {
      landingURL,
      isVerified: false,
      isLoggedIn: false,
    }
  },
  computed: {
    getTitle() {
      return this.isVerified ? 'Vaš profil je već verificiran.' : 'Uspješna potvrda e-maila'
    },
    getButtonText() {
      return this.isLoggedIn ? 'nastavi' : 'login'
    },
  },
  async mounted() {
    await this.confirmEmail()
    await this.checkIfUserIsAlreadyLoggedIn()
  },
  methods: {
    async handleRedirect() {
      const path = this.isLoggedIn ? '/' : '/login'
      await this.$router.push(path)
    },
    async confirmEmail() {
      const { errors } = await this.$apollo.mutate({
        mutation: CONFIRM_EMAIL,
        variables: { token: this.token },
      })

      if (errors && errors.length > 0) {
        this.isVerified = !!errors.find(error => error.message === VERIFIED_MESSAGE_RESPONSE)
      }
    },
    async checkIfUserIsAlreadyLoggedIn() {
      const { data } = await this.$apollo.query({
        query: GET_LOGGED_USER,
      })

      this.isLoggedIn = !!data.me
    },
  },
}
</script>

<style scoped>
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}
.main-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 42rem;
  justify-self: center;
}
.successful-text-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  margin-top: 4.5rem;
}
.successful-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 800;
  font-size: 72px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.03em;
  color: #333333;
}
</style>
